var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteerLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 173,
    viewBox: "0 0 130 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8761 52.9232C66.1097 52.9232 76.8377 42.1952 76.8377 28.9616C76.8377 15.728 66.1097 5 52.8761 5C39.6425 5 28.9146 15.728 28.9146 28.9616C28.9146 42.1952 39.6425 52.9232 52.8761 52.9232Z",
    stroke: "#F7F7F5",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2714 67.3008H43.1948C34.7124 67.3008 27.2843 72.8599 24.8402 80.9589L14.5846 115.224H5",
    stroke: "#F7F7F5",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4992 120.016V167.939H28.9146",
    stroke: "#F7F7F5",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2539 120.016V167.939H76.8385",
    stroke: "#F7F7F5",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0078 75.5484C98.8353 70.1331 104.826 66.5868 111.487 67.4494C119.155 68.4078 124.762 75.3088 124.762 83.0244C124.762 91.363 121.455 99.3662 115.56 105.261L96.0078 124.813L76.4551 105.261C70.5606 99.3662 67.2539 91.363 67.2539 83.0244C67.2539 74.8775 73.4839 67.7848 81.6309 67.3535C87.8609 67.0181 93.372 70.4206 96.0078 75.5484Z",
    stroke: "#F7F7F5",
    strokeWidth: 9.58463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerLight);
export default __webpack_public_path__ + "static/media/volunteer_light.aa074c49dfcc1cd54cf0f15543476ec6.svg";
export { ForwardRef as ReactComponent };